module.exports = __webpack_public_path__ + "static/wasabi-3-102ad93c432d0739e75c679c0a135b37.png";